import React from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';

import Xpeer from '../HomeLite/patterns/Xpeer/Xpeer';
import GradientNumbers from '../HomeLite/patterns/GradientNumbers/GradientNumbers';

import HeroLite from './patterns/HeroLite/HeroLite';
import Divider from './patterns/Divider/Divider';
import CuentaMGM from './patterns/CuentaMGM/CuentaMGM';
import CreditoMGM from './patterns/CreditoMGM/CreditoMGM';
import Blocks from './patterns/Blocks/Blocks';

const MGMHomePage = () => (
  <ParallaxProvider>
    <HeroLite />
    <Divider />
    <CuentaMGM />
    <CreditoMGM />
    <GradientNumbers />
    <Blocks />
    <Xpeer mgm />
  </ParallaxProvider>
);

export default MGMHomePage;
